import { PushNotifications } from '@capacitor/push-notifications';
import { NotificationStatus } from '../../../core/enums';
import { isPushNotificationAvailable } from '../../../lib/utils';

const isUnreadNotification = (status: string) =>
	[NotificationStatus.New, NotificationStatus.Pushed].includes(status as NotificationStatus);

export default isUnreadNotification;

export const isPushNotificationGranted = async () => {
	if (!isPushNotificationAvailable) return false;

	const status = await PushNotifications.checkPermissions();
	return status.receive === 'granted';
};
